import { ThemedView,ThemedPressable,ThemedText } from "@app/theme";
import { Info} from '@app/sharedComponents/Icons/Icons';
import { Alert, Image, Platform, ToastAndroid,Clipboard } from "react-native";
import CopyIcon from "../../../../assets/Icons/CopyIcon";
import { ThemedTouchableOpacity } from "@app/theme/Components";

const BankTransferDetails = ({userName,bankTransferDetails})=>{
    const copyToClipboard = (text) => {
        Clipboard.setString(text);
        if(Platform.OS==='android'){
            ToastAndroid.show("Copied to clipboard!", ToastAndroid.SHORT)
        } else{
            Alert.alert("Copied to clipboard!")
        }
    }
    return(
        <>
        <ThemedView backgroundColor="border-primary" height={1} width={'100%'} />
        <ThemedView pt='lg' >
        <ThemedView flexDirection="row">
        <ThemedView width={30} height={30} backgroundColor="text-disabled"  borderRadius="full" borderColor="border-secondary" borderWidth={5} alignItems="center" justifyContent="center">
                <ThemedText variant="b4r" color="white">
                    1
                </ThemedText>
            </ThemedView>
            <ThemedView flex={1} ml='md'>
                <ThemedText variant="b3m" color="text-secondary">
                    Check your bank account
                </ThemedText>
                <ThemedView flexDirection="row" flexWrap="wrap">
                    <ThemedText  variant="b4r" color="text-secondary">
                    Bank account should be in the name of 
                    </ThemedText>
                    <ThemedText  variant="b4s" color="text-secondary">
                    {" "}{userName}
                    </ThemedText>
                </ThemedView>
                <ThemedView mt="lg"  p="md" flexDirection="row" alignItems="center" backgroundColor="bg-fill-warning" borderRadius="sm">
                    <ThemedView>
                    <Info size={16} weight="fill"  color="#f9bd21"/>
                    </ThemedView>
                    <ThemedText variant="b4r" color="text-primary" ml="sm">
                    Transactions made via other bank account can result in accounting delays or rejections
                    </ThemedText>
                </ThemedView>
            </ThemedView>
        </ThemedView>
        <ThemedView flexDirection="row" mt="2xl">
            <ThemedView width={30} height={30} backgroundColor="text-disabled" borderRadius="full" borderColor="border-secondary" borderWidth={5} alignItems="center" justifyContent="center">
                <ThemedText variant="b4r" color="white">
                    2
                </ThemedText>
            </ThemedView>
            <ThemedView flex={1} ml='md'>
                <ThemedText  variant="b3m" color="text-secondary" mb="xs">
                Add beneficiary
                </ThemedText>
                    <ThemedText variant="b4r" color="text-secondary" mb="lg">
                    Add beneficiary via net banking or pay at your bank branch.
                    </ThemedText>
                
                <ThemedView p="lg" borderWidth={1} borderColor="border-primary" borderRadius="sm">
                    <ThemedView  mb="lg" flexDirection="row" alignItems="center">
                    <Image
                            source={{uri:`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankTransferDetails?.bankCode??'default'}.png`}}
                            style={{width: 40, height: 40}}
                        />
                <ThemedText variant="b4r" color="text-primary">
                {bankTransferDetails?.bankName}
                </ThemedText>
                </ThemedView>
                <ThemedView backgroundColor="border-primary" height={1} width={'100%'} />
                <ThemedView my="md">
                    <ThemedText variant="b4r" color="text-primary">
                    Account number
                    </ThemedText>
                    <ThemedView flexDirection="row" alignItems="center" justifyContent="space-between">
                        <ThemedText variant="b4s" color="text-primary">
                        {bankTransferDetails?.accountNumber}
                        </ThemedText>
                        <ThemedTouchableOpacity flexDirection="row" alignItems="center" onPress={()=>copyToClipboard(bankTransferDetails?.accountNumber)}>
                            <CopyIcon size={16} color="#1434cb"/>
                            <ThemedText variant="b4r" color="text-action-primary">
                            Copy
                            </ThemedText>
                        </ThemedTouchableOpacity>
                    </ThemedView>
                </ThemedView>
                <ThemedView backgroundColor="border-primary" height={1} width={'100%'} />
                <ThemedView my="md">
                    <ThemedText variant="b4r" color="text-primary">
                    Beneficiary name
                    </ThemedText>
                    <ThemedView flexDirection="row" alignItems="center" justifyContent="space-between">
                        <ThemedText variant="b4s" color="text-primary">
                        {bankTransferDetails?.beneficiaryName}
                        </ThemedText>
                        <ThemedTouchableOpacity flexDirection="row" alignItems="center" onPress={()=>copyToClipboard(bankTransferDetails?.beneficiaryName)}>
                            <CopyIcon size={16} color="#1434cb"/>
                            <ThemedText variant="b4r" color="text-action-primary">
                            Copy
                            </ThemedText>
                        </ThemedTouchableOpacity>
                    </ThemedView>
                </ThemedView>
                <ThemedView backgroundColor="border-primary" height={1} width={'100%'} />
                <ThemedView my="md">
                    <ThemedText variant="b4r" color="text-primary">
                    Beneficiary type
                    </ThemedText>
                    <ThemedView flexDirection="row" alignItems="center" justifyContent="space-between">
                        <ThemedText variant="b4s" color="text-primary">
                        {bankTransferDetails?.beneficiaryType}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedView backgroundColor="border-primary" height={1} width={'100%'} />
                <ThemedView my="md">
                    <ThemedText variant="b4r" color="text-primary">
                    IFSC
                    </ThemedText>
                    <ThemedView flexDirection="row" alignItems="center" justifyContent="space-between">
                        <ThemedText variant="b4s" color="text-primary">
                        {bankTransferDetails?.ifscCode}
                        </ThemedText>
                        <ThemedTouchableOpacity flexDirection="row" alignItems="center" onPress={()=>copyToClipboard(bankTransferDetails?.ifscCode)}>
                            <CopyIcon size={16} color="#1434cb"/>
                            <ThemedText variant="b4r" color="text-action-primary">
                            Copy
                            </ThemedText>
                        </ThemedTouchableOpacity>
                    </ThemedView>
                </ThemedView>
                <ThemedView backgroundColor="border-primary" height={1} width={'100%'} />
                <ThemedView my="md">
                    <ThemedText variant="b4r" color="text-primary">
                    Branch name
                    </ThemedText>
                    <ThemedView flexDirection="row" alignItems="center" justifyContent="space-between">
                        <ThemedText variant="b4s" color="text-primary">
                        {bankTransferDetails?.branchName}
                        </ThemedText>
                        <ThemedTouchableOpacity flexDirection="row" alignItems="center" onPress={()=>copyToClipboard(bankTransferDetails?.branchName)}>
                            <CopyIcon size={16} color="#1434cb"/>
                            <ThemedText variant="b4r" color="text-action-primary">
                            Copy
                            </ThemedText>
                        </ThemedTouchableOpacity>
                    </ThemedView>
                </ThemedView>

                </ThemedView>
            </ThemedView>
        </ThemedView>
        <ThemedView flexDirection="row" mt="2xl">
        <ThemedView width={30} height={30} backgroundColor="text-disabled"  borderRadius="full" borderColor="border-secondary" borderWidth={5} alignItems="center" justifyContent="center">
                <ThemedText variant="b4r" color="white">
                    3
                </ThemedText>
            </ThemedView>
            <ThemedView flex={1} ml='md'>
                    <ThemedText  variant="b4r" color="text-secondary">
                    The amount will get reflected in your loan account within 1-2 business hours. Check the <ThemedText  variant="b4b" color="text-secondary">transactions</ThemedText> tab to track progress.
                    </ThemedText>
            </ThemedView>
        </ThemedView>
        </ThemedView>
        </>
    )
}

export default BankTransferDetails;